<template>
  <div>
    <h1 class="header">Icon Search</h1>
    <p class="scala">--- ICON SEARCH ---</p>
    <div class="button-container">
      <input v-model="searchQuery" @input="searchImages" maxlength="30" @focus="playOpenSound" placeholder="Search Icons" />
    </div>
    <div class="button-container" style="margin-top: -1em;">
      <button @mousedown="setFilter('All')" :class="{ active: filter === 'All' }"><h3>All</h3></button>
      <button @mousedown="setFilter('Detailed')" :class="{ active: filter === 'Detailed' }"><h3>Detailed</h3></button>
      <button @mousedown="setFilter('Minimal')" :class="{ active: filter === 'Minimal' }"><h3>Minimal</h3></button>
    </div>
    <div class="image-results">
      <li v-for="(result, index) in searchResults" :key="index">
        <div class="image-container" @click="downloadImage(result)"
             @mouseover="showTooltip(index)" @mouseleave="hideTooltip()">
          <img :src="result" class="image" />
          <div class="tooltip" v-if="hoveredIndex === index">
            {{ getImageName(result) }}
            <img src="@/assets/Download.svg" class="download" />
          </div>
        </div>
      </li>
    </div>
  </div>
</template>

<script>
import selectSound from "@/assets/audio/select.mp3";
import openSound from "@/assets/audio/open.mp3";
export default {
  name: 'IconSearch',
  data() {
    return {
      searchQuery: '',
      searchResults: [],
      filter: 'All',
      hoveredIndex: null,
    };
  },
  methods: {
    searchImages() {
      this.searchResults = [];
      if (this.searchQuery.trim() !== '') {
        this.performSearch();
      }
    },
    performSearch() {
      const searchWords = this.searchQuery.toLowerCase().split(' ');
      let baseDir;
      if (this.filter === 'Detailed') {
        baseDir = require.context("@/assets/images/Detailed", true, /\.png$/);
      } else if (this.filter === 'Minimal') {
        baseDir = require.context("@/assets/images/Minimal", true, /\.png$/);
      } else {
        baseDir = require.context("@/assets/images", true, /\.png$/);
      }
      const imagePaths = baseDir.keys().map(baseDir);
      imagePaths.forEach((path) => {
        const pathLowerCase = path.toLowerCase();
        const filename = pathLowerCase.split('/').pop().replace(/\.\w+$/, '');
        const fileWords = filename.split(/\s+/);
        const isMatch = searchWords.every((searchWord) =>
          fileWords.some((fileWord) => fileWord.startsWith(searchWord))
        );
        if (isMatch) {
          this.searchResults.push(path);
        }
      });
    },
    setFilter(newFilter) {
      if (this.filter !== newFilter) {
        this.filter = newFilter;
        const selectAudio = new Audio(selectSound);
        selectAudio.play();
        this.searchImages();
      }
    },
    playOpenSound() {
      const openAudio = new Audio(openSound);
      openAudio.play();
    },
    getImageName(imagePath) {
      return imagePath.replace(/.*\//, '').replace(/\..*$/, '');
    },
    showTooltip(index) {
      this.hoveredIndex = index;
    },
    hideTooltip() {
      this.hoveredIndex = null;
    },
    downloadImage(imagePath) {
      const selectAudio = new Audio(selectSound);
      selectAudio.play();
      const link = document.createElement('a');
      link.href = imagePath;
      link.download = this.getImageName(imagePath);
      link.click();
    },
  },
};
</script>

<style scoped>
input {
  font-family: "KHMenu", Roboto, sans-serif;
  font-size: calc(0.75em + 0.75vw);
  font-weight: normal;
  width: clamp(20em, 60vw, 35em);
  padding: 0.5em 1.5em;
}
input:focus {
  border: 2px solid var(--blue-light);
  color: var(--white);
}
button {
  font-family: "KHMenu", Roboto, sans-serif;
  padding: 0.5em 1.5em;
}
.image-results {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  list-style: none;
  min-height: 15em;
  padding: 5vw 3vw;
  margin: 0;
  color: var(--white);
  background: linear-gradient(to bottom, var(--black), var(--black) 50%, var(--indigo) 50%, var(--indigo));
  background-size: 100% 5px;
  border: none;
  outline: 2px solid var(--blue-light);
  filter: drop-shadow(0 0 1em var(--indigo)) drop-shadow(0 0 0.5em var(--indigo));
}
@media screen and (min-width: 1200px) {
  .image-results {
    border-radius: 0.5em;
  }
}
.image-container {
  width: calc(3em + 3vw);
  height: calc(3em + 3vw);

  display: flex;
  justify-content: center;
  align-items: center;
}
.image {
  max-width: 100%;
  max-height: 100%;
  aspect-ratio: auto 1/1;
  user-select: none;
}
.image-container:active {
  .tooltip {
    background-color: var(--blue-light);
    color: var(--black);
    border: 1.5px solid var(--blue-light);
  }
  .download {
    filter: brightness(1000%) invert(1);
  }
}
.tooltip {
  position: absolute;
  background-color: #000000CC;
  color: var(--blue-light);
  padding: 0.25em 1em;
  border-radius: 1em;
  font-size: 0.75em;
  pointer-events: none;
  z-index: 100;
  border: 1.5px solid var(--blue);
}
.download {
  width: 1em;
  height: 1em;
  transform: translateY(1px);
}
</style>